var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_993_2175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5 11.3086C21.5 16.346 17.9521 20.5556 13.2188 21.5737V14.9883H15.2818H15.711L15.7761 14.5641L16.2638 11.3844L16.3521 10.8086H15.7695H13.2188V9.24609C13.2188 8.88332 13.3084 8.58676 13.4809 8.38718C13.6417 8.20117 13.9368 8.02734 14.5114 8.02734H15.8984H16.3984V7.52734V4.82031V4.3984L15.9825 4.32744L15.8984 4.82031L15.9824 4.32742L15.9823 4.3274L15.982 4.32734L15.981 4.32718L15.9776 4.32661L15.9656 4.3246L15.9208 4.31734C15.8822 4.31117 15.8263 4.30246 15.7557 4.29207C15.6146 4.27131 15.4144 4.24374 15.1758 4.21619C14.7008 4.16135 14.0643 4.10547 13.4361 4.10547C12.0788 4.10547 10.9014 4.51867 10.0627 5.3581C9.22358 6.19803 8.78125 7.40694 8.78125 8.88516V10.8086H6.48828H5.98828V11.3086V14.4883V14.9883H6.48828H8.78125V21.5737C4.04793 20.5556 0.5 16.346 0.5 11.3086C0.5 5.5096 5.20101 0.808594 11 0.808594C16.799 0.808594 21.5 5.5096 21.5 11.3086Z",
    fill: "white",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2818 14.4883L15.7695 11.3086H12.7188V9.24609C12.7188 8.37619 13.145 7.52734 14.5114 7.52734H15.8984V4.82031C15.8984 4.82031 14.6397 4.60547 13.4361 4.60547C10.9235 4.60547 9.28125 6.12828 9.28125 8.88516V11.3086H6.48828V14.4883H9.28125V22.175C10.4202 22.3531 11.5798 22.3531 12.7188 22.175V14.4883H15.2818Z",
    fill: "url(#paint0_linear_993_2175)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_993_2175",
    x1: 11.1934,
    y1: 4.60547,
    x2: 11.1934,
    y2: 22.3086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#063065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3370BC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_993_2175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0 0.308594)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/FacebookIcon.be9d176dcc547bfb8a9b85de589e4b13.svg";
export { ForwardRef as ReactComponent };